"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var ui_1 = require("@aperza/ui");
var CatalogPartnerCard = function (props) {
    var documentId = props.documentId, available = props.available, status = props.status;
    var sendMessage = ui_1.useReactiveMessage('CATALOG_PARTNER').sendMessage;
    var t = react_i18next_1.useTranslation(['catalog']).t;
    var isButtonDisabled = function () {
        var disabled = false;
        if (status === 7 || !available) {
            disabled = true;
        }
        return disabled;
    };
    var onClick = function () {
        if (!isButtonDisabled()) {
            sendMessage({
                documentId: documentId,
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "aw-inquiry-card", id: "catalog-partner-card" },
            react_1.default.createElement("p", { className: "title mb-4" }, t('catalog.partner.title')),
            react_1.default.createElement("p", { className: "mb-4" }, t('catalog.partner.description')),
            react_1.default.createElement("a", { className: clsx_1.default('btn btn-default btn-xl btn-block text-wrap partnerCatalog', {
                    disabled: isButtonDisabled(),
                }), href: "javascript:void(0)", onClick: onClick }, t('catalog.partner.button')),
            status === 7 && react_1.default.createElement("p", { className: "text-danger text-center" }, "\u65E2\u306B\u7533\u8ACB\u6E08\u3067\u3059"))));
};
CatalogPartnerCard.displayName = 'CatalogPartnerCard';
exports.default = CatalogPartnerCard;
